import React from 'react';
import NavBar from '../NavBar';
import { Footer } from './Footer';
import { BlogCard } from './BlogCard';
import { blog, blogTitle } from '../../constants/Footer/blog';
import './Blog.css';

export const Blog = () => {
  return (
    <>
      <NavBar currentPath="blogs" />
      <div className="blogContainer">
        <h1 className="header"> {blogTitle.blogTitle} </h1>
        <p className="headerp"> {blogTitle.blogSubtitle}</p>
        <div className="blogCard">
          {blog.map((blog) => (
            <BlogCard
              key={blog.id}
              imageUrl={blog.imageUrl}
              title={blog.title}
              description={blog.description}
              date={blog.date}
              link={`/blogs/${blog.id}`}
            />
          ))}
        </div>
      </div>
      <Footer currentPath={'/blogs'} />
    </>
  );
};
